<script setup lang="ts">
/**
 * Homepage teaser for /job-application-tracker: what the Applications board
 * does in three lines, a still of it, and a link to the page that explains it.
 */
const { t } = useI18n()

const points = ['where', 'stage', 'followUp', 'opened'] as const
</script>

<template>
  <section class="sofax bg-white dark:bg-gray-950">
    <div class="section-space">
      <div class="shell">
        <div class="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-20">
          <div class="relative order-2 mx-auto w-full max-w-[34rem] lg:order-1">
            <MarketingTrackerMockBoard />
          </div>
          <div class="order-1 lg:order-2">
            <div class="eyebrow mb-5">{{ t('homepage.tracker.eyebrow') }}</div>
            <h2 class="mb-5">{{ t('homepage.tracker.title') }}</h2>
            <p class="!mb-8 text-lg">{{ t('homepage.tracker.text') }}</p>
            <ul class="mb-10 flex flex-col gap-3">
              <li v-for="point in points" :key="point" class="flex items-start gap-3">
                <i class="bi bi-check-circle-fill mt-0.5 shrink-0 text-xl text-accent" />
                <span class="text-base">{{ t(`homepage.tracker.points.${point}`) }}</span>
              </li>
            </ul>
            <SofaxBtn to="/job-application-tracker" :label="t('homepage.tracker.cta')" variant="dark" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
